import { notEmptyString } from "./helpers"

export const validDateString = (date, withTime) => {
  let valid = typeof date === 'string';
  if (valid) {
    let pattern = '^\\s*[12]\\d\\d\\d-[0-1]?\\d-[0-3]\\d?';
    if (withTime === true) {
      pattern += `(T|\\s)[0-2]?\\d:[0-5]?\\d:[0-5]?\\d(\\.\\d+)?Z?`;
    }
    pattern += '\\s*$';
    const rgx = new RegExp(pattern, 'i');
    valid = rgx.test(date);
  }
  return valid;
}

export const validDateTimeString = (date) => {
  return validDateString(date, true);
}

export const validUKPostcode = postcode => {
  return /\b((?:(?:gir)|(?:[a-pr-uwyz])(?:(?:[0-9](?:[a-hjkpstuw]|[0-9])?)|(?:[a-hk-y][0-9](?:[0-9]|[abehmnprv-y])?)))) ?([0-9][abd-hjlnp-uw-z]{2})\b/i.test(postcode);
}

export const isValidAddress = (address) => {
  let checkFields = [];
  if (address instanceof Object) {
    const { street, locality, postcode } = address;
    if (!notEmptyString(street, 1)) {
      checkFields.push('street');
    }
    if (!notEmptyString(locality, 2)) {
      checkFields.push('locality');
    }
    if (!address.countryCode) {
      address.countryCode = 'GB';
    }
    switch (address.countryCode) {
      case 'GB':
      case 'CA':
      case 'UK':
        if (!validUKPostcode(postcode)) {
          checkFields.push('postcode');
        }
        break;
    }
  }
  return {
    checkFields,
    valid: checkFields.length < 1
  };
}

export const validPassword = (pass) => {
  let valid = false;
  if (typeof pass === 'string') {
    pass = pass.trim();
    if (pass.length >= 8) {
      valid = /[a-z]/.test(pass) && /[A-Z]/.test(pass) && /[0-9]/.test(pass) && /^[a-z0-9_;:.,-]+$/i.test(pass);
    }
  }
  return valid;
}

export const validEmail = (identifier) => {
  let valid = false;
  if (typeof identifier === 'string') {
    valid = identifier.length > 5 && /^[^@]+@\w/.test(identifier);
  }
  return valid;
}

export const validPhoneNumber = (code) => {
  if (typeof code === 'string') {
    //return /^(\s*\+\s*)?[0-9) \)\(-]+\d\d\s*\d+[0-9) \)\(-]+$/.test(code);
    return /^(\s*\+\s*)?[0-9) )(-]+\d\d\s*\d+[0-9) )(-]+$/.test(code);
  }
}

export const matchUKPhone = (code) => {
  let type = "mobile";
  if (typeof code === 'string') {
    type = (validPhoneNumber(code) && /^(\s*\+?(00)?44\s+)?\b0(1[1-9]|2)/.test(code)) ? "landlne" : "mobile";
  }
  return type;
}

export const isUntitled = title => {
  return notEmptyString(title) && title.indexOf('[untitled]') >= 0;
}

export const validMediaTitle = title => {
  return title.trim().length > 2 && !isUntitled(title);
}

export const validateMediaItem = item => {
  if (item instanceof Object) {
    if (item.filename.length > 5 && item.title) {
      return validMediaTitle(item.title);
    }
    return false;
  }
}

export const isInvalidMediaItem = item => {
  if (item instanceof Object) {
    return !validateMediaItem(item)
  }
  return false;
}

export const matchCollege = (submission, colleges) => {
  let matched = false;
  if (submission instanceof Object && colleges instanceof Array) {
    const { college, collegeName } = submission;
    if (collegeName) {
      const rgx = new RegExp('^\\s*' + collegeName.toLowerCase().replace(/[^a-z0-9]+/g, '.*'), 'i');
      const mc = colleges.find(c => rgx.test(c.label));

      if (mc) {
        matched = mc.id === college
      }
    }
  }
  return matched;
}

export const hasCollectionAddress = submission => {
  let has = false;
  if (submission.collectionAddress) {
    if (notEmptyString(submission.collectionAddress.street) && notEmptyString(submission.collectionAddress.postcode)) {
      has = submission.collectionAddress.street !== submission.address.street;
    }
  }
  return has;
}

export const buildResourceRegex = () => {
  const urlParts = ['www\\.vimeo\\.com/', 'vimeo\\.com/', 'player\\.vimeo\\.com/video/', 'player\\.vimeo\\.com/\\w+/playback/'];
  const idParts = ['\\d+?\\b']
  return new RegExp('^https?://(' + urlParts.join('|') + ')(' + idParts.join('|') + ')', 'i');
}

export const validResourceUrl = resourceUrl => {
  return buildResourceRegex().test(resourceUrl);
}